import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { DayWindow } from "@starsach/shared-types";

/** UI state only (CLAUDE.md section 11): the day-window toggle and what the user has minimised. List filters are local to each DataTable. Server state lives in TanStack Query. */
export type ConcurrencyChannel = "voice" | "chats" | "email" | "tasks";

interface UiState {
  window: DayWindow;
  setWindow: (w: DayWindow) => void;
  /** The environment the person last looked at: where an environment-scoped module opens from the nav (section 8.9). */
  lastEnvironmentId?: string;
  setLastEnvironment: (environmentId: string) => void;
  /** The Polly voice announcements are previewed in; a preference of the ear, not of the configuration. */
  previewVoice: string;
  setPreviewVoice: (voice: string) => void;
  /** Channels the user has minimised on the Concurrency tab; remembered so next time they see only what they care about. */
  concurrencyMinimised: ConcurrencyChannel[];
  toggleConcurrencyChannel: (c: ConcurrencyChannel) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      window: 30,
      setWindow: (window) => set({ window }),
      setLastEnvironment: (lastEnvironmentId) => set({ lastEnvironmentId }),
      previewVoice: "Joanna",
      setPreviewVoice: (previewVoice) => set({ previewVoice }),
      concurrencyMinimised: [],
      toggleConcurrencyChannel: (c) =>
        set((s) => ({ concurrencyMinimised: s.concurrencyMinimised.includes(c) ? s.concurrencyMinimised.filter((x) => x !== c) : [...s.concurrencyMinimised, c] })),
    }),
    { name: "starsach-ui", partialize: (s) => ({ window: s.window, concurrencyMinimised: s.concurrencyMinimised, lastEnvironmentId: s.lastEnvironmentId, previewVoice: s.previewVoice }) },
  ),
);
